import React from 'react';

import QuestionShell from '../QuestionShell';
import useQuestionForm from '../QuestionShell/useQuestionForm';

function BarcodeQuestion({
  identifier, pages, info, mode, handleDeleteQuestion, handleDuplicateQuestion,
}) {
  const question = useQuestionForm({ identifier, pages, info });

  return (
    <QuestionShell
      {...question}
      identifier={identifier}
      info={info}
      mode={mode}
      titleVariant="welcomeTitle"
      titleKey="task.taskEdition.barcodeQuestionText.question"
      descriptionKey="task.taskEdition.barcodeQuestionText.description"
      handleDeleteQuestion={handleDeleteQuestion}
      handleDuplicateQuestion={handleDuplicateQuestion}
    />
  );
}

export default BarcodeQuestion;
